import { useUserPrefs } from "@/lib/stores/user-prefs";
import { en } from "./en";
import { fr } from "./fr";
import { keys } from "./keys";

export const useT = () => {
  const prefs = useUserPrefs();
  const language = prefs?.language ?? "en";
  return { keys, fr, en }[language];
};
